const routes = [
    {
        path: '/emissor/backup_dados',
        component: () => import('../views/BackupDados')
    }
]

export default routes
